import React, { createContext, useContext, useState } from "react";
import { login as loginService, register as registerService } from "../services/authService";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const login = async (email, password) => {
    try {
      const token = await loginService(email, password);
      localStorage.setItem("token", token);
      setUser({ email });
      return true;
    } catch (err) {
      console.error("Login failed:", err);
      return false;
    }
  };

  const register = async (email, password) => {
    try {
      await registerService(email, password);
      return true;
    } catch (err) {
      console.error("Register failed:", err);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
